import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import {
    CreatePosterMutation,
    CreatePosterMutationVariables,
    UpdatePosterMutation,
    UpdatePosterMutationVariables,
    DeletePosterMutation,
    DeletePosterMutationVariables,
    UpdatePosterSpaceMutation,
    UpdatePosterSpaceMutationVariables,
    ImportPosterMutation,
    ImportPosterMutationVariables,
} from 'generated/graphql'

const createPosterMutation = gql`
    mutation createPoster($data: CreatePosterInput!) {
        createPoster(data: $data) {
            id
        }
    }
`
export const createPoster = (data) => {
    const mutation = graphql.createQuery<
        CreatePosterMutation, CreatePosterMutationVariables
    >(createPosterMutation)

    return mutation({ data })
}

const updatePosterMutation = gql`
    mutation updatePoster($id: ID!, $data: UpdatePosterInput!) {
        updatePoster(id: $id, data: $data) {
            id
            preview
            pdf
        }
    }
`
export const updatePoster = (id, data) => {
    const mutation = graphql.createQuery<
        UpdatePosterMutation, UpdatePosterMutationVariables
    >(updatePosterMutation)

    return mutation({ id, data })
}

const deletePosterMutation = gql`
    mutation deletePoster($id: ID!) {
        deletePoster(id: $id)
    }
`
export const deletePoster = (id) => {
    const mutation = graphql.createQuery<
    DeletePosterMutation, DeletePosterMutationVariables
    >(deletePosterMutation)

    return mutation({ id })
}

const updatePosterSpaceMutation = gql`
    mutation updatePosterSpace($id: Int!, $data: UpdatePosterSpaceInput!) {
        updatePosterSpace(posterSpace: $id, data: $data) {
            id
            parent {
                image
            }
        }
    }
`
export const updatePosterSpace = (id, data) => {
    const mutation = graphql.createQuery<
        UpdatePosterSpaceMutation, UpdatePosterSpaceMutationVariables
    >(updatePosterSpaceMutation)

    return mutation({ id, data })
}

const importPosterMutation = gql`
    mutation importPoster($posterSpace: ID!, $data: [ImportPoster!]!) {
        importPoster(posterSpace: $posterSpace, data: $data) {
            successCount
            errorCount
            errorItems {
                id
                message
                hiddenMessage
            }
        }
    }
`
export const importPosters = (posterSpace, data) => {
    const mutation = graphql.createQuery<
        ImportPosterMutation, ImportPosterMutationVariables
    >(importPosterMutation)

    return mutation({ posterSpace, data })
}
